import { FC, ReactNode } from 'react';

import { Flex, StyleProps, Text } from '@bonusly/design-system';

import { formatDisplayName } from '../../features/recognition/utils/user';
import { UserBonusFeedProps } from '../../types/user';
import { UserAvatar } from './UserAvatar';

interface Props extends StyleProps {
	description?: ReactNode;
	user: UserBonusFeedProps;
}

export const UserCard: FC<Props> = ({ description, user, ...rest }: Props) => (
	<Flex {...rest}>
		<UserAvatar user={user} mr={3} size="lg" />

		<Flex direction="column" flex={1} justifyContent="center" minWidth={0}>
			<Text fontSize="lg" fontWeight={500} lineHeight={7} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
				{user.display_name}
			</Text>

			<Text color="gray.600" fontSize="sm" fontWeight="normal" lineHeight={5} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
				{description || formatDisplayName(user)}
			</Text>
		</Flex>
	</Flex>
);
